import { PageResponse } from '..';
import { User } from './user';
import { ProjectBranch } from './branch';
import { Clientfile } from './clientfile';
import { UserGroup } from './user-group';
import {Customer, ReleaseBundle} from '.';



export interface ProjectProtectionSettings {
    binaryProtection?: boolean;
    assetProtection?: boolean;
}
export interface Platform {
    name?: string;
}
export interface ProjectStatistics {
    playersTotal?: number;
    playersSuspicious?: number;
    playersBanned?: number;
    currentPlayers?: number;
    playersAccused?: number;
}
export interface Project extends ProjectProtectionSettings, ProjectStatistics {
    id?: string;
    name?: string;
    image?: any;
    imageContents?: string;
    status?: string;
    creationDate?: string;
    modifyDate?: any;
    projectBranches?: ProjectBranch[];
    externalId?: string;
    projectSecurityFeatures?: ProjectSecurityFeature[];
    platform?: Platform;
    customer?: Customer;
    projectSettings?: ProjectSettings[];
}
export interface ProjectSettings {
  id: string;
  name: string;
  displayName: string;
  projectSettingType: string;
  value: string;
  description: string;
  nullable: boolean;
  internal: boolean;
}
export interface ProjectStatistics {
  playersTotal?: number;
  playersSuspicious?: number;
  playersBanned?: number;
  currentPlayers?: number;
  playersAccused?: number;
}


export interface ProjectPluginResponse {
    plugins: ProjectPlugin[];
}
export interface ProjectPlugin {
    name: string;
    description: string;
    value: boolean;
}

export class CreateProjectRequest {
    constructor(public name: string, public externalId: string, public image: any,
        public customerName: string, public createAdminGroupAccess: boolean, public platformName: string) {}
}

export class UpdateProjectSecurityFeature {
    constructor(public projectSecurityFeatures: ProjectSecurityFeature[]) {}
}

export class UpdateProjectSettingRequest {
  constructor(public id: string, public value: string){}
}

export class ProjectResponse extends PageResponse {
    content: Project[];
}

export interface ProjectAccess {
    id: string;
    project: Project;
    user: User;
    userGroup: UserGroup;
    role: string;
    creationDate: string;
    modifyDate: string;
}

export class ProjectSecurityFeature {
    securityFeatureType: string;
    status: ProjectSecurityFeatureStatus;
}

export enum DetectionType {
    MANUAL = 'MANUAL',
    AUTO = 'AUTO'
}

export interface TelemetryEventsByDay {
  day: string;
  events: number;
}

export interface TelemetryEventsByEvent {
    eventType: string;
    count: number;
}

export enum ProjectSecurityFeatureStatus {
    OFF = 'OFF',
    COLLECT_DATA = 'COLLECT_DATA',
    DETECT_CHEATS = 'DETECT_CHEATS'
}

export class AddProjectMemberRequest {
    constructor(public projectId: string, public memberId: string, public groupId: string, public role: string) { }
}

export class DeleteProjectMemberRequest {
    constructor(public projectId: string, public accessId: string) { }
}

export class DetectionSettingUpdatePreviewRequest {
    detectionType: DetectionType;
    trustScoreLimit: number;
    suspicionScoreLimit: number;
}

export class DetectionSettingUpdatePreviewResponse {
    estimatedNumberOfAdditinalDetections: number;
}
